<ion-header no-border>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title color="dark" class="ion-text-center" style="margin-right: 10% !important;">{{title}}</ion-title>

  </ion-toolbar>
</ion-header>

<ion-content class="padding" style="overflow-y: hidden;">

  <div *ngIf="type === 'download-qr'" class="segmentSectionOverflow centerAlign">
    <div class="segmentSection">
      <button #micrositeOverlayElement class="segmentButton bigButton"
        [ngClass]="{'enabledSegment' : (segmentValue === 'micrositeOverlay')}"
        (click)="segmentChanged('micrositeOverlay', micrositeOverlayElement)"
        data-cy="microsite-with-sign-in-overlay-segment">
        Open House Sign-in
      </button>
      <button #micrositeElement class="segmentButton bigButton"
        [ngClass]="{'enabledSegment' : (segmentValue === 'microsite')}"
        (click)="segmentChanged('microsite', micrositeElement)" data-cy="microsite-segment">
        Marketing Microsite
      </button>
    </div>
  </div>

  <!-- <p class="centerAlign">{{helperText}}</p> -->

  <div class="QRwrapper">

    <ion-icon name="refresh-circle" class="link refreshQR"
      *ngIf="!refreshingQR && !(userRole === 'lender' && type === 'download-qr')" (click)="refreshQRCode()"
      data-cy="refresh-qr"></ion-icon>
    <ion-spinner class="spinner-loader" name="crescent" *ngIf="refreshingQR"></ion-spinner>

    <div *ngIf="type !== 'your-qr'" id="screenWrapper">

      <ion-img *ngIf="currentQRData && !refreshingQR" id="screen" #screen [src]="currentQRData" alt="Listing QR Code"
        title="Listing QR Code" data-cy="listing-qr-code-image"></ion-img>

    </div>

    <div *ngIf="type === 'your-qr'" id="screenWrapper">

      <ion-img *ngIf="currentQRData && !refreshingQR" id="screen" #screen [src]="currentQRData" alt="Dynamic QR Code"
        title="Dynamic QR Code" data-cy="listing-qr-code-image"></ion-img>

    </div>
  </div>


  <div *ngIf="type === 'your-qr'" class="your-qr-code-body">
    <p class="qr-code-title">
      One QR Code for everything <span class="link" (click)="showQRCodeInfo()">
        <ion-icon class="slotButtonIcon noTooltip" slot="icon-only" name="information-circle-sharp"></ion-icon>
      </span>
    </p>
    <div class="spacer-10"></div>
    <p class="message">
      Change the landing page content anytime and this QR Code stays the same
    </p>
  </div>

  <!-- <p class="highlightable full-width centerAlign">{{url}}</p> -->

  <ion-item lines="none" class="ion-item-custom centerAlign">
    <ion-label class="link" (click)="copyVal(origUrl)">
      <span class="lbl">{{origUrl}}</span>
    </ion-label>
    <div class="btnWrap">
      <ion-button class="copy-button" slot="end" fill="clear" (click)="copyVal(origUrl)">
        <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
      </ion-button>
    </div>
    <!-- <div *ngIf="!listingQR" class="btnWrap">
      <ion-button class="share-button" slot="end" fill="clear" (click)="shareVal(origUrl)">
        <ion-icon slot="icon-only" name="share-outline"></ion-icon>
      </ion-button>
    </div> -->
  </ion-item>


  <div class="downloadBttn">
    <ion-button *ngIf="type === 'your-qr'" ion-button class="update-langing-page" (click)="updateLandingPage()"> Update
      Landing
      Page </ion-button>
    <ion-button ion-button fill="outline" (click)="downloadImage()">Download QR Code</ion-button>

    <div id="download">
      <img id="canvas" #canvas>
      <a id="downloadLink" #downloadLink></a>
    </div>

  </div>

</ion-content>